import i18n from '@/lib/i18n'

export const FAVORITE_TITLE = i18n.t('favorite.title')
export const FAVORITE_TITLE_ALIAS = i18n.t('favorite.titleAlias')
